import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
  rotate?: string
}

const EmailIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props
  return (
    <svg
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : '100%'}
      height={height ? height : '100%'}
    >
      <path
        d="M25.3333 0H6.66667C4.89921 0.00211164 3.20474 0.703344 1.95496 1.94988C0.705176 3.19642 0.00211714 4.88648 0 6.64935L0 22.6078C0.00211714 24.3707 0.705176 26.0607 1.95496 27.3073C3.20474 28.5538 4.89921 29.255 6.66667 29.2571H25.3333C27.1008 29.255 28.7953 28.5538 30.045 27.3073C31.2948 26.0607 31.9979 24.3707 32 22.6078V6.64935C31.9979 4.88648 31.2948 3.19642 30.045 1.94988C28.7953 0.703344 27.1008 0.00211164 25.3333 0ZM6.66667 2.65974H25.3333C26.1317 2.66131 26.9114 2.90113 27.5719 3.34835C28.2325 3.79557 28.7438 4.42973 29.04 5.16921L18.8293 15.3547C18.0779 16.1012 17.0606 16.5203 16 16.5203C14.9394 16.5203 13.9221 16.1012 13.1707 15.3547L2.96 5.16921C3.2562 4.42973 3.76748 3.79557 4.42806 3.34835C5.08864 2.90113 5.86829 2.66131 6.66667 2.65974ZM25.3333 26.5974H6.66667C5.6058 26.5974 4.58839 26.1771 3.83824 25.4289C3.08809 24.6807 2.66667 23.6659 2.66667 22.6078V8.64416L11.2853 17.2351C12.5368 18.4802 14.2323 19.1794 16 19.1794C17.7677 19.1794 19.4632 18.4802 20.7147 17.2351L29.3333 8.64416V22.6078C29.3333 23.6659 28.9119 24.6807 28.1618 25.4289C27.4116 26.1771 26.3942 26.5974 25.3333 26.5974Z"
        fill="black"
      />
    </svg>
  )
}

export default EmailIcon
